<expanded-panel
  *ngIf="selectedKpi && (expanded || hasRenderedPanel)"
  [open]="expanded"
  (closed)="onCollapsed()"
  (closedAll)="onClosedAll()"
>
  <div expanded-panel-header-content class="portfolio-kpi-expanded-header">
    <div class="portfolio-kpi-expanded-title-row">
      <h2>{{ selectedKpi.kpi.name }}</h2>
      <span class="portfolio-kpi-expanded-title-divider" aria-hidden="true"></span>
      <span class="portfolio-kpi-expanded-studies-text">{{ portfolioExpandedStudiesText }}</span>
    </div>
    <div class="portfolio-kpi-sidepanel-header">
      <ng-container *ngIf="!(isHeaderLoading || isSummaryLoading); else expandedHeaderSkeleton">
        <div class="portfolio-kpi-sidepanel-values">
          <span class="portfolio-kpi-sidepanel-secondary-value">{{
            portfolioKpiSecondaryValue
          }}</span>
          <span class="portfolio-kpi-sidepanel-divider">|</span>
          <span class="portfolio-kpi-sidepanel-display-value">{{ portfolioKpiDisplayValue }}</span>
        </div>

        <div class="portfolio-kpi-sidepanel-trend-with-label">
          <span class="portfolio-kpi-sidepanel-meta-label">Trend since last week:</span>
          <span class="portfolio-kpi-sidepanel-trend">
            <kpi-trend-indicator
              [trendIndicator]="selectedKpi.kpi.trendIndicator"
              [trendChange]="selectedKpi.kpi.trendChange"
              [kpiType]="selectedKpi.kpi.type"
              [kpiName]="selectedKpi.kpi.name"
              [showPlaceholder]="true"
            ></kpi-trend-indicator>
          </span>
        </div>

        <div class="portfolio-kpi-sidepanel-status" *ngIf="selectedKpi.kpi.health as health">
          <span class="portfolio-kpi-sidepanel-meta-label">KPI is:</span>
          <status-badge [type]="'kpiHealth'" [badgeKey]="health"></status-badge>
        </div>
      </ng-container>

      <ng-template #expandedHeaderSkeleton>
        <div class="portfolio-kpi-expanded-header-skeleton">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{
              width: '150px',
              height: '22px',
              'border-radius': '4px',
              display: 'block',
              margin: '0'
            }"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{
              width: '220px',
              height: '22px',
              'border-radius': '4px',
              display: 'block',
              margin: '0'
            }"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{
              width: '130px',
              height: '24px',
              'border-radius': '12px',
              display: 'block',
              margin: '0'
            }"
          ></ngx-skeleton-loader>
        </div>
      </ng-template>

      <div class="portfolio-kpi-expanded-header-actions">
        <filter-menu
          [variant]="'kpi-expanded'"
          [label]="'Filters'"
          [columnTitleMappings]="columnTitleMappings"
          [useExternalState]="true"
          [externalFiltersApplied]="kpiFiltersApplied"
          [externalTotalFiltersApplied]="totalKpiFiltersApplied"
          (externalRemoveFilter)="kpiRemoveFilter.emit($event)"
          (externalClearAll)="kpiClearAllFilters.emit()"
        ></filter-menu>
      </div>
    </div>
  </div>
  <div expanded-panel-body class="portfolio-kpi-expanded-body">
    <div class="portfolio-kpi-extended-layout">
      <div class="portfolio-kpi-extended-top-row">
        <kpi-chart-card
          [title]="'Average cycle time'"
          [variant]="'expanded'"
          [cardType]="'cycle'"
          [isLoading]="isCycleLoading"
          [showCycleTooltipText]="false"
          [timeCycleChartData]="timeCycleChartData"
          (expandClicked)="openExpandedChart('Average cycle time', 'cycle')"
        ></kpi-chart-card>

        <kpi-chart-card
          [title]="'Milestone status summary'"
          [variant]="'expanded'"
          [cardType]="'summary'"
          [isLoading]="isSummaryLoading"
          [infoTooltipTitle]="'Milestone status summary'"
          [infoTooltipText]="'KPI tooltip info coming soon.'"
          [milestoneStatusSummaryData]="milestoneStatusSummaryData"
          (summaryStatusClicked)="summaryStatusFilterToggle.emit($event)"
          (expandClicked)="openExpandedChart('Milestone status summary', 'summary')"
        ></kpi-chart-card>
      </div>

      <kpi-table-card
        [enableSort]="true"
        [hasData]="true"
        [infoTooltipTitle]="'Milestone summary table'"
        [infoTooltipText]="'KPI tooltip info coming soon.'"
        (expandClicked)="openExpandedTable()"
      ></kpi-table-card>
    </div>
  </div>
</expanded-panel>
